export const data = [
    {
        name: "Complain About NLPC PFA Services?",
        faqs: [
            {
                id: 1,
                question: 'To make a complaint',
                answer: `<div class="answer-group">
The following options are available channels through which complaints, requests, enquiries may be lodged:
<ol class="my-4">
<li>You may reach us by calling <a href="tel:07000-CALL-NLPCPFA" target="_blank" rel="noreferrer">07000-CALL-NLPCPFA</a> <a href="tel:0700022556572732" target="_blank" rel="noreferrer">(07000-2255-6572732)</a></li>
<li>Send a complaint using your registered email address to: <a href="mailto:csu@nlpcpfa.com" target="_blank" rel="noreferrer">csu@nlpcpfa.com</a></li>
<li>Chat with us from our website via: <a href="http://www.nlpcpfa.com" target="_blank" rel="noreferrer">www.nlpcpfa.com</a>.</li>
<li>Send a letter to us via our Head Office address: NLPC Pension FundAdministrators Limited, 312, Ikorodu Road, Anthony, Lagos.</li>
<li>Visit any of our branches nationwide.</li>
<li>Social media platforms: 
<a href="https://www.facebook.com/nlpcpfa" target="_blank" rel="noreferrer">Facebook</a>
<a href="https://twitter.com/nlpcpfa" target="_blank" rel="noreferrer">Twitter</a>
<a href="https://www.linkedin.com/company/3255322" target="_blank" rel="noreferrer">LinkedIn</a>
</li>
</ol>
</div>`,
            },
        ]
    },
    {
        name: "What do I Need to Change my information",
        faqs: [
            {
                id: 2,
                question: 'Documents for change of name (Female)',
                answer: `
        <divclass="answer-group">
<ol>
<li>Request letter for change of name</li>
<li>A copy of marriage certificate (if change of surname is due marriage)</li>
<li>Affidavit for change of name</li>
<li>NIN Slip indicating new name</li>
<li>The full page of the newspaper publication notifying the public of your change of name (Please note that the newspaper page heading must include the name and date of publication as well as the page number).</li>
</ol>
</div>`
            },
            {
                id: 3,
                question: 'Documents for change of name (Male)',
                answer: `
<div class="answer-group">
<ol>
<li>Request letter for change of name</li>
<li>Affidavit for change of name</li>
<li>NIN Slip indicating new name</li>
<li>The full page of the newspaper publication notifying the public of your change of name (Please note that the newspaper page heading must include the name and date of publication as well as the page number).</li>
</ol>
</div>`
            },
            {
                id: 4,
                question: 'Change in Date of Birth',
                answer: `
<div class="answer-group">
<div>The RSA holder will undergo the recapturing exercise furnishing us with the under listed documents:</div>
<ol>
<li>Request letter for change of Date of Birth</li>
<li>National Identity Card or Enrolment Slip issued by the National Identity Management Commission</li>
<li>Evidence of payment / Remita Receipt from NIMC</li>
<li>Letter of employment /Confirmation from employer</li>
<li>Birth Certificate of Declaration of Age</li>
<li>New RSA form to be completed by the RSA Holder</li>
</ol>
</div>`
            },
            {
                id: 5,
                question: 'Can I change my next of kin or register more than one person as next of kin on my account?',
                answer: `
<div class="answer-group">
<div>Yes. Your Next of Kin (NOK) can be changed. However, if you would like to add additional names, a formal instruction will be required.</div>
</div>`
            },
            {
                id: 6,
                question: 'How can I change my login details?',
                answer: `
<div class="answer-group">
  <div>Kindly provide your Full Name, PIN, Employer name and send a request mail to <a href="mailto:csu@nlpcpfa.com" target="_blank" rel="noreferrer">csu@nlpcpfa.com</a>.</div>
</div>
        ` },
        ]
    },
    {
        name: "About Contributory Pension Scheme (CPS)",
        faqs: [
            {
                id: 7,
                question: 'What is the new scheme?',
                answer: `<div class="answer-group">
        The new scheme is a Contributory Pension Scheme (CPS), fully funded, privately managed pension scheme that is based on individual accounts. It ensures that everyone who has worked <b>receives his/her retirement benefit as and when due</b>.
        </div>`
            },
            {
                id: 8,
                question: 'What are the objectives of the Contributory Pension Scheme?',
                answer: `
<div class="answer-group">
        Ensure that every person who has worked in either the public or private sector receives his/her retirement benefits as an when due; Assist employees by ensuring that they save to cater for their livelihood during old age; Establish a uniform set of rules, regulations and standards for the administration and payment of pension fund in the country: and to stop the growth of outstanding pension liabilities.
        </div>
        `},
            {
                id: 9,
                question: 'How does it work?',
                answer: `
<div class="answer-group">
        A minimum of 18% (employer -10%, employee - 8%) of an employee’s monthly emolument is to be contributed by the employee and employer. (Emolument = Basic Salary + Housing+ Transport Allowance).
        </div>
        `},
            {
                id: 10,
                question: 'What are the advantages and disadvantages of the new scheme?',
                answer: `
<div class="answer-group">
        The new scheme is contributory and fully funded; it encourages individual savings towards retirement; money is available to pay retirees. Retired workers can collect their benefits as and when due; we have checks and balances because pension administration and investment is separated from fund custody and control; and the accumulated contributions bring about development in the economic activities. A major disadvantage is that employees are made to contribute towards their retirement.
        </div>
        `},
            {
                id: 11,
                question: 'What are the advantages and disadvantages of the new scheme?',
                answer: `
<div class="answer-group">
        The new scheme is contributory and fully funded; it encourages individual savings towards retirement; money is available to pay retirees. Retired workers can collect their benefits as and when due; we have checks and balances because pension administration and investment is separated from fund custody and control; and the accumulated contributions bring about development in the economic activities. A major disadvantage is that employees are made to contribute towards their retirement.
        </div>
        `},
            {
                id: 12,
                question: 'What are the advantages and disadvantages of the old scheme?',
                answer: `
<div class="answer-group">
        The old scheme was funded only by the employer. However, the disadvantages include: corruption, outright theft, mismanagement and serial abuse of the pension administration, retirees were not paid as and when due or paid at all; huge pension liability because no money was set aside for pension especially in the public sector; some employers do not have any pension arrangement in the private sector and where it existed, most of the workers squandered their pension benefits when they were in active service.
        </div>
        `},
            {
                id: 13,
                question: 'What will happen to the contribution?',
                answer: `
<div class="answer-group">
        The total contribution will be paid out by the employer directly to a Pension Fund Custodian (PFC) and will be managed and invested by the Pension Fund Administrator (PFA), of the employees’ choice.
        </div>
        `},
            {
                id: 14,
                question: 'Who is a Pension Fund Administrator?',
                answer: `
<div class="answer-group">
        A Pension Fund Administrator is an entity licensed by the National Pension Commission (PENCOM) and charged with the responsibility of managing and investing pension funds. Each employee is free to choose his or her preferred PFA.
        </div>
        `},
            {
                id: 15,
                question: 'Who is a Pension Fund Custodian?',
                answer: `
<div class="answer-group">
        A Pension Fund Custodian is an entity licensed by the National Pension Commission to keep pension funds and assets in safe custody.
        </div>
        `},
            {
                id: 16,
                question: 'Who is the Regulator, and what role does he play?',
                answer: `
<div class="answer-group">
        The National Pension Commission (PENCOM) is charged with the regulation and supervision of the operators as well as formulates, direct and oversee the overall policy on pension matters in Nigeria.
        </div>
        `},
            {
                id: 17,
                question: 'What is Retirement Savings Account?',
                answer: `
<div class="answer-group">
        This is like a bank account. Every contributor will open a Retirement Savings Account (RSA) with a Pension Fund Administrator of his/her choice. The PFA will be required to issue a statement of account at least once every quarter. Unlike a bank account, withdrawal from RSA is only at retirement, death, or loss of job.
        </div>
        `},
            {
                id: 18,
                question: 'Are pension contributions paid to the PFAs?',
                answer: `
<div class="answer-group">
        No. The employer sends both the employee’s as well as the employer’s monthly contributions directly to the Custodian.
        </div>
        `},
            {
                id: 19,
                question: 'What makes NLPC Pension Fund Administrator different from other PFAs?',
                answer: `
<div class="answer-group">
        Our experience, integrity, expertise and door-to-door personalized service delivery to clients stands us out among our numerous competitors out there. NLPC PFA is simply a name synonymous with pensions because of our pedigree.
        </div>
        `},
            {
                id: 20,
                question: 'What happens to my account when I change job?',
                answer: `
<div class="answer-group">
        Your RSA is portable and mobile which will remain with you for life. Simply notify your new employer of the PFA that manages your account and the PFA’s account details for monthly Pension Remittance.
        </div>
        `},
            {
                id: 21,
                question: 'What happens if my new employer does not use my PFA?',
                answer: `
<div class="answer-group">
         The Retirement Savings Account (RSA) is a portable and mobile account; once you advise your new employer of your PIN and PFA, your new employer is expected to remit your existing RSA. Alternatively, the Act allows RSA holder to transfer once a year without any reason, hence, you may switch to the PFA used by your new company, if you so wish.
        </div>
        `},
            {
                id: 22,
                question: 'Can I switch PFAs?',
                answer: `
<div class="answer-group">
        Yes. As a RSA Holder, you have the freedom to move once a year from one PFA to another (without any reason). 
        </div>
        `}
        ]
    },
    {
        name: "Remittance of pension contributions",
        faqs: [
            {
                id: 23,
                question: 'How can I keep track the performance of my contributions?',
                answer: `
<div class="answer-group">
  <div>Pension Fund Administrators are mandated to issue quarterly statements to employees. SMS transaction alerts are usually transmitted through registered mobile numbers, once contributions are credited into respective RSAs. RSA Holders may also request for statement of account through letter notification or email via <a href="mailto:csu@nlpcpfa.com" target="_blank" rel="noreferrer">csu@nlpcpfa.com</a>,</div>
  <div>
  Alternatively, RSA Holders can access their statements of accounts through any of our self-service platforms below:
  <ol>
  <li>Website: (<a href="www.nlpcpfa.com" target="_blank" rel="noreferrer">www.nlpcpfa.com</a>) using log-in details</li>
  <li>PENSMART APP: Below are the links for Android and iPhone users:
  <ul>
  <li><a href="https://play.google.com/store/apps/detailsid=com.nidcomsolutions.pfa.nlpc.Nlpc_Droid"  target="_blank" rel="noreferrer">https://play.google.com/store/apps/detailsid=com.nidcomsolutions.pfa.nlpc.Nlpc_Droid</a></li>
  <li><a href="https://apps.apple.com/us/app/pensmart/id1448022895?ls=1"  target="_blank" rel="noreferrer">https://apps.apple.com/us/app/pensmart/id1448022895?ls=1</a></li>
</ul> 
<li>whatsapp: <a href="https://wa.link/nfbmud" target="_blank">CLINT-0904 444 4040</a> </li>
  </li>
</ol>
  </div>
</div>
        ` },
            {
                id: 24,
                question: 'Can I make additional contributions into my account?',
                answer: `
<div class="answer-group">

   <p>     A RSA holder can make additional contributions to his account as Voluntary Contributions (VC). VCs are supplementary contributions that can be made alongside your mandatory contributions to your Retirement Savings Account (RSA). Remittance of VC must come through your employer. The payment schedule provided to your employer, has a column for VC: this column should be imputed with the amount you choose to contribute as VC.</p>
<p>Please note that your VC will be credited to your existing RSA and your statement of account will also show the details of your VCs to enable you monitor the growth. </p>
        </div>
        `},
            {
                id: 25,
                question: 'I haven’t received any email or SMS alerts in a while. Why?',
                answer: `
<div class="answer-group">
   This may be because your mobile telephone number has changed, and you are yet to update your new phone number on our records. If your mobile telephone number is correct, it could mean that we have not received any contributions on your behalf recently.
        </div>
        `},
            {
                id: 26,
                question: 'What can I do if my employer fails to remit my monthly pension contributions?',
                answer: `
<div class="answer-group">
The Pension Reform Act 2014 requires employers to remit pension contributions on behalf of their employees within 7 working days from the payment of salaries. The Act also provides that where the employer fails to either deduct or remit the contributions within the stipulated time, the employer will be liable to pay a penalty that is not less than 2% of the total outstanding contributions that remains unpaid for each month or part of each month the default continues. Kindly note that employees are therefore required to liaise with their employers to ensure that their pension contributions are remitted into their Retirement Savings Accounts.
        </div>
        `},
            {
                id: 27,
                question: 'Can I use my pension contributions as collateral for securing loan?',
                answer: `
<div class="answer-group">
No, pension contributions are non-assignable, non-transferable and cannot be used as collateral for any loan (under review). It is basically meant to serve you at old age/retirement when you can no longer actively cater for yourself.
        </div>
        `},
            {
                id: 28,
                question: 'Can I borrow part of the contributions in my RSA to help me out of pressing financial crises?',
                answer: `
<div class="answer-group">
<p>
No, the RSA does not run like your bank account or cooperative account, so it is impossible for you to withdraw any part from your RSA. </p>
<p>
However, if you have Additional Voluntary Contributions, you may access the contingent part of your AVC, in accordance with the terms and conditions laid down by PENCOM.
</p>
        </div>
        `},
            {
                id: 29,
                question: 'Is it possible for my employer to access my contribution at any time for whatever reason?',
                answer: `
<div class="answer-group">
No, the Retirement Savings Account is a personal account and can only be accessed by the owner except in the case of death. However, some states may delay or deny employees access their pension contributions until issues of indebtedness with their employers are resolved.
        </div>
        `},
            {
                id: 30,
                question: 'How and where do you invest my pension contributions?',
                answer: `
<div class="answer-group">
Pension contributions are invested in line with the provisions of pension Act and investment guidelines. The permissible area of investment includes government bond, treasury bills, money market, stock markets, mutual fund, real estate etc. The return on such investment is added to the fund less management fees as prescribed by PenCom.

        </div>
        `},
            {
                id: 31,
                question: 'What will happen to my contributions under the RSA if I move to employer with DBS?',
                answer: `
<div class="answer-group">
Your contributions will remain in your Retirement Savings Account (RSA) till you finally retire from work. Yet, you can contribute voluntarily to keep the account growing. However, the National Pension Commission will give the final pronouncement to the client on how to access the benefits under the CPS and DBS whether it will be merged or administered separately.
        </div>
        `},
            {
                id: 32,
                question: 'How safe are my contributions in the event of liquidation of my PFA or PFC?',
                answer: `
<div class="answer-group">
Your contributions are insulated from crises. This is because PFAs and PFCs are only carrying out the administrative and investment functions and monies are not really in their custody but invested in varieties of instruments. Where a PFA or PFC liquidates, the various investments in their custody will be transferred to another PFA or PFC as the case may be. It should be noted the National Pension Commission is fully aware of all the transactions and in possession of relevant data.
        </div>
        `},
        ]
    },
    {
        name: "Statements of accounts",
        faqs: [
            {
                id: 33,
                question: 'Why is my RSA reading zero balance?',
                answer: `
<div class="answer-group">
This is most likely because your employer is yet to remit your monthly pension contributions. Kindly liaise with your employer or PFA on the way forward. For public employees (Federal), please liaise with your Organization’s Pension Desk Officer (PDO).
        </div>
        `},
            {
                id: 34,
                question: 'I do not understand some of the terms used on the statement, please explain.',
                answer: `
<div class="answer-group">
<p><b>Contributions Received from Inception:</b> This is the sum of contributions received on your behalf from your employer before any investment activity by us, less N100 Admin fee/month.</p>
<p><b>Total Withdrawals from Inception:</b> This refers to the total amount of money that has been paid out to you as Voluntary Contribution (VC), retirement benefit payments or the total withdrawals made on your account based on the advice of your employer.</p>
<p><b>Gain/Loss from Inception:</b> This refers to the profit or loss made on your account as a result of investing your monthly contributions. It is worth mentioning that the gains outweigh the losses in most cases because of the strict investment guidelines that have been placed on pension funds by our Regulator, the National Pension Commission (PenCom).</p>
<p><b>Current Value:</b> This is the addition of your total net contributions and the growth on your contributions, after your contributions have been invested. This means that your current balance is usually higher than your actual pension contributions because the contributions are constantly being invested. As a result, your current balance changes daily.</p>
<p><b>Units:</b> This represents the number of units allotted to you at the point of crediting your Retirement Savings Account (RSA) with the contribution received on your behalf. Mathematically, it is arrived at by dividing the contribution received by the fund price of the previous day. The total unit for a given period (e.g. a year) will be sum total of all the allotted units per monthly remittance. </p>
<p><b>Unit Price:</b> This is the prevailing fund price on a given day. This mathematically is calculated as the total contributions brought in a day divided by the total allotted units of the previous day.</p>
        </div>
        `},
            {
                id: 35,
                question: 'Why does my account balance fluctuate?',
                answer: `
<div class="answer-group">
The difference observed in your Retirement Savings Account (RSA) balances is a result of the changes in the RSA Fund’s unit price. These price changes are a summary of the investing activities of the fund. The unit price of the RSA Fund is computed by dividing the Net Asset Value (NAV) of the Fund (contributions + appreciation/depreciation) by the actual contributions received. However, because up to 25% of the Fund can be invested in stocks (whose prices rise or fall daily) the unit price of the Fund may appreciate or depreciate over time. We expect the RSA Fund to appreciate over the long term.
        </div>
        `},
        ]
    },
    {
        name: "Payments of benefits at retirement",
        faqs: [
            {
                id: 36,
                question: 'When can I have access to the fund in my account?',
                answer: `
<div class="answer-group">
The difference observed in your Retirement Savings Account (RSA) balances is a result of the changes in the RSA Fund’s unit price. These price changes are a summary of the investing activities of the fund. The unit price of the RSA Fund is computed by dividing the Net Asset Value (NAV) of the Fund (contributions + appreciation/depreciation) by the actual contributions received. However, because up to 25% of the Fund can be invested in stocks (whose prices rise or fall daily) the unit price of the Fund may appreciate or depreciate over time. We expect the RSA Fund to appreciate over the long term.
        </div>
        `},
            {
                id: 37,
                question: 'Can I withdraw any portion of it?',
                answer: `
<div class="answer-group">
Yes. If the employee resigned or disengaged from service and he is below age 50. He or She is entitled to 25% of his/her Retirement Savings Account (RSA) balance, if after four (4) months of such disengagement from work, the employee has not secured a new job.
        </div>
        `},
            {
                id: 38,
                question: 'How do I receive my retirement benefit?',
                answer: `
<div class="answer-group">
The difference observed in your Retirement Savings AccounAt retirement or upon reaching age 50 – when you are no longer in employment, the amount in your RSA shall be used to purchase a programmed withdrawal or purchase an annuity that would guarantee an amount of not less than 50% of your last annual remuneration (subject to RSA balance) to be paid to you monthly or quarterly as pension for life (in case of annuity).
        </div>
        `},
            {
                id: 39,
                question: 'What is Fund Programmed Withdrawal?',
                answer: `
<div class="answer-group">
A programmed withdrawal is the method by which the employee collects his accumulated benefits as lump sum and thereafter, by periodic payments usually monthly or quarterly for the length of an estimated life span. The lump sum benefits, and monthly pension is expected to be paid into the Retiree’s bank account. Only PFAs are licensed to offer this product.
        </div>
        `},
            {
                id: 40,
                question: 'What is Annuity?',
                answer: `
<div class="answer-group">
An annuity is an income with monthly or quarterly payments during the lifetime of a retiree that is purchased from a licensed life insurance company approved by the National Pension Commission. The single premium for this is first deducted from the employee’s RSA. The balance, if any, would then be taken as lump sum.
        </div>
        `},
            {
                id: 41,
                question: 'How much do I receive as benefit at retirement?',
                answer: `
<div class="answer-group">
If a Retiree’s recommended monthly pension is less than N10,000, the entire benefit is paid En Bloc. However, where the recommended monthly pension is more than N10,000,  the employee is entitled to a minimum of 25% and up to 50% en bloc payment as well as monthly pension for an estimated life span.
        </div>
        `},
            {
                id: 42,
                question: 'Would I have access to all my money after retirement?',
                answer: `
<div class="answer-group">
A Retiree is entitled to lump sum payment and thereafter, monthly pension drawdowns based on Programmed Withdrawal or Annuity option. However, if a Retiree’s recommended monthly pension is less than N10,000, the entire benefit is paid En Bloc.
        </div>
        `},
            {
                id: 43,
                question: 'Can I continue to contribute to my RSA after I have retired and accessed my retirement benefits?',
                answer: `
<div class="answer-group">
Yes. A Retiree on monthly pensions, who secures another employment after retirement can continue to contribute to his RSA. The contributions received will be credited to the retiree’s account as Voluntary Contributions and can be accessed after disengagement from the new employer.
        </div>
        `},
            {
                id: 44,
                question: 'What happens to my benefit in the event of death?',
                answer: `
<div class="answer-group">
The named beneficiary(ies) will be entitled to the benefit from the compulsory life insurance policy, the total past benefits (accrued rights/bonds), which will be added to the RSA balance, under the contributory pension scheme. The benefits would be paid en bloc into the named beneficiary’s (ies’s) bank account(s).
        </div>
        `},
            {
                id: 45,
                question: 'How long will it take to process my benefit after retirement?',
                answer: `
<div class="answer-group">
At NLPC PFA, we are desirous to pay your retirement benefits in less than one month from the date of submitting all the required documentations.
        </div>
        `},
            {
                id: 46,
                question: 'Why does it take a longer time to pay the death benefit?',
                answer: `
<div class="answer-group">
Most of the death cases are usually without a Will, which means that the beneficiary would have to apply to the Probate Registry for Letter of Administration which takes a long time to secure. Employees are therefore advised to write their Will, through the service of a competent lawyer.
        </div>
        `},
            {
                id: 47,
                question: 'Who is a beneficiary?',
                answer: `
<div class="answer-group">
This is a person (s) recognized by law to be entitled to all the benefits payable to a deceased employee or client, through the instrumentality of a Will or Letter of Administration.
        </div>
        `},
            {
                id: 48,
                question: 'Who is a next of kin?',
                answer: `
<div class="answer-group">
This is a named person(s) to be contacted in the absence of the client for information purpose.
        </div>
        `},
        ]
    },
    {
        name: "Accessing RSA Balance for Payment of Equity Contribution for Residential Mortgage by RSA Holders",
        faqs: [
            {
                id: 49,
                question: 'Background',
                answer: `
<div class="answer-group">
The Guidelines on Accessing Retirement Savings Account (RSA) Balance towards Payment of Equity Contribution for Residential Mortgage by RSA Holders (The Guidelines) is in line with the provisions of Section 89 (2) of the Pension Reform Act (PRA 2014), which allow RSA holders to utilize part of their retirement savings as equity contribution for the purpose of securing Residential Mortgage
        </div>
        `},
            {
                id: 50,
                question: 'Who is covered under this guideline?',
                answer: `
<div class="answer-group">
<ol>
<li>Employees in active service or self-employed persons who are making monthly/periodic contributions to either RSA Funds I, II, III, V or Active Fund VI, registered with a licensed PFA and meets the eligibility criteria</li>
<li>Pension Fund Administrators (PFAs) and Pension Fund Custodians (PFCs) Licensed by the Commission to manage and keep custody of pension assets respectively.</li>
<li>Mortgage lenders licensed by the Central Bank of Nigeria (CBN) to provide mortgage financial services</li>
</ol>
The Guidelines on Accessing Retirement Savings Account (RSA) Balance towards Payment of Equity Contribution for Residential Mortgage by RSA Holders (The Guidelines) is in line with the provisions of Section 89 (2) of the Pension Reform Act (PRA 2014), which allow RSA holders to utilize part of their retirement savings as equity contribution for the purpose of securing Residential Mortgage
        </div>
        `},
            {
                id: 51,
                question: 'Who is eligible?',
                answer: `
<div class="answer-group">
<ol>
<li>RSA holders in active employment, either as a salaried employee or as a self-employed person.</li>
    <li>The RSA Holder, whose RSA has both employer and employee’s mandatory contributions for a cumulative minimum period of 60 months prior to the application.</li>
    <li>A Micro Pension Contributor who has made contributions for a minimum of 60 months prior to his/her application.</li>
    <li>Married couples, who are RSA holders and wishes to make a joint application, subject to individually satisfying the eligibility requirements set out in the Guidelines.</li>
    <li>The RSA holder who registered before 1 July 2019 and have updated his/her records through the RSA Data Recapture Exercise.</li>
    <li>The RSA holder who has secured an Offer Letter for the property duly signed by the property owner and verified by the Mortgage Lender.</li>
</ol>
        </div>
        `},
            {
                id: 52,
                question: 'Who is not eligible?',
                answer: `
<div class="answer-group">
<ol>
<li>RSA holders in active employment, either as a salaried employee or as a self-employed person.</li>
    <li>RSA Holders that have less than 3 years to retirement shall not be eligible to use a portion of their RSA balances as equity contribution for residential mortgage.</li>
    <li>Existing Retirees on CPS and exempted persons under the PRA 2014 shall not be eligible to use their RSA balances for payment of equity contribution for Residential Mortgage.</li>
</ol>
        </div>
        `},
            {
                id: 53,
                question: 'What is the limit for equity contribution?',
                answer: `
<div class="answer-group">
<ol>
<li>The maximum amount to be applied as equity contribution for residential mortgage shall be 25% of the total RSA balance as at the date of application irrespective of the percentage of equity contribution required by the Mortgage Lender.</li>
    <li>Where the value of 25% of RSA balance is more than the required equity contribution, the RSA holder can only access an amount equivalent to the equity contribution required by the Mortgage Lender.</li>
    <li>Where the value of 25% of the RSA is lower than the equity contribution required by the Mortgage Lender, the RSA holder shall deposit the difference with the Mortgage Lender before 25% of his/her RSA balance can be applied as equity contribution.</li>
</ol>
        </div>
        `},
            {
                id: 54,
                question: 'Can an applicant use his/her voluntary contribution (VC) for equity contribution?',
                answer: `
<div class="answer-group">
Yes, an applicant may utilize the contingent portion of his/her Voluntary Contribution (VC) for equity contribution, in line with the Voluntary Contribution Guidelines under the CPS, after meeting the provision in the Guideline
        </div>
        `},
            {
                id: 55,
                question: 'Can an applicant use his/her NSITF and pre-scheme contributions for equity contribution?',
                answer: `
<div class="answer-group">
NSITF and Pre-Scheme contributions in respect of an active RSA contributor may form part of the RSA balance considered in determining the 25% of equity contribution for RSA Residential Mortgage.
        </div>
        `},
            {
                id: 56,
                question: 'Can an applicant utilise all his/her contributions under MPP for equity contribution?',
                answer: `
<div class="answer-group">
No, the applicant may utilize only the contingent portion of his/her contribution, in line with the Guidelines for Micro Pension Plan, after meeting the Eligibility Criteria.
        </div>
        `},
            {
                id: 57,
                question: 'At what point does an applicant need to sign a consent form with his or her PFA?',
                answer: `
<div class="answer-group">
<ol>
<li>An Applicant shall sign a consent with his/her PFA where he/she wishes to include his/her VC contingent portion, NSITF and Pre-Scheme contribution as equity contribution.</li>
    <li>Where a Micro Pension Contributor wishes to include his/her contingency portion as equity contribution, he/she shall sign a consent with his/her PFA to that effect.</li>
    <li>Where an RSA holder had accessed his/her RSA balance for residential mortgage, he/she shall sign a consent with his/her PFA before accessing 25% due to loss of job.</li>
    <li>Where an RSA had accessed his/her RSA balance due to loss of job, he/she shall sign a consent with his/her PFA before accessing his RSA balance for residential mortgage</li>
</ol>
        </div>
        `},
            {
                id: 58,
                question: 'I have accessed 25% of my RSA balance due to loss of job, can I still apply for 25% equity contribution?',
                answer: `
<div class="answer-group">
Yes, RSA Holders who had accessed their RSA balances due to loss of employment prior to the issuance of these Guidelines shall be eligible to access their RSAs for equity contribution, provided their RSAs had received employer and employee contributions for a minimum of 60 months from the date of first contribution.
        </div>
        `},
            {
                id: 59,
                question: 'I have accessed 25% of equity contribution, can i still apply for 25% of my RSA balance due to loss of job?',
                answer: `
<div class="answer-group">
Yes, RSA holders that have utilised 25% of their RSA balance for equity contribution for residential mortgage shall be eligible for payment of 25% of their RSA for loss of job in line with the provision of Section 7(2) of PRA 2014.
        </div>
        `},
            {
                id: 60,
                question: 'I have accessed 25% of my RSA balance due to loss of job and 25% equity contribution, can I still access lumpsum at retirement?',
                answer: `
<div class="answer-group">
Oh yes, where an RSA holder had accessed his/her RSA balance for residential mortgage and 25% due to loss of job, he/she shall access lump sum at retirement in line with section 7(1)(a) of the PRA, 2014 and subject to guidelines issued by the Commission.
        </div>
        `},
            {
                id: 61,
                question: 'Can my NOK or beneficiary apply for the equity contribution on my behalf?',
                answer: `
<div class="answer-group">
No, Application for equity contribution for residential mortgage shall be in person and not by proxy.
        </div>
        `},
            {
                id: 62,
                question: 'How many times can I access equity contribution for residential mortgage?',
                answer: `
<div class="answer-group">
An RSA holder can only access his/her RSA once, for equity contribution towards residential mortgage.
        </div>
        `},
            {
                id: 63,
                question: 'I have other needs, can I use the equity contribution to meet those other needs?',
                answer: `
<div class="answer-group">
No, the funds released from the RSA for payment of equity contribution can only be used exclusively for residential mortgage. RSA holder and the Mortgage Lender shall indemnify the PFA on the exclusive use of the funds released from the RSA for payment of equity contribution.
        </div>
        `},
            {
                id: 64,
                question: 'Can I use any mortgage lender of my choice?',
                answer: `
<div class="answer-group">
Yes, you are at liberty to choose your Mortgage Lender, provided that:
    <ol>
    <li>The Mortgage Lender has been licensed by the CBN to provide residential mortgage and shall have met the minimum capital requirement as prescribed by the CBN from time to time.</li>
    <li>The Mortgage Lender shall be always in good financial standing and shall satisfy the minimum requirements of the CBN, in terms of industry uniform underwriting standards, assets/liabilities management policy, foreclosure procedure, liquidity, capital adequacy, overall asset quality, profitability and any other requirement, as may be prescribed by the CBN from time to time.</li>
    <li>The Mortgage Lender shall also comply with the provisions of Sections 2 and 4 (1) and (5) of PRA, 2014.</li>
    <li>The Mortgage Lender shall have a valid Pension Clearance Certificate issued by the Commission in line with the PRA, 2014.</li>
    <li>The Commission shall liaise with the CBN on an annual basis to determine the Mortgage Lenders that meet the stipulated minimum requirements of these Guidelines and other conditions as may be specified by the CBN from time to time.</li>
    <li>The names of Mortgage Lenders that meet the eligibility criteria of these Guidelines shall be published on the Commission’s website on a bi-annual basis or when any new license is issued by the CBN.</li>
</ol>
        </div>
        `},
            {
                id: 65,
                question: 'Please explain the process involved?',
                answer: `
<div class="answer-group">
<ol>
<li>The applicant shall obtain a property offer letter from the property owner or approved agent and approach a Mortgage Lender.</li>
<li>The applicant shall fill an application for mortgage form, which shall be provided by the Mortgage Lender and attach the property offer letter.</li>
<li>The Mortgage Lender shall review the application form and verify the genuineness of the property offer.</li>
<li>The Mortgage Lender shall do its due diligence to ensure that the property has a valuation report.</li>
<li>Upon confirmation of the property offer letter, the applicant shall approach his/her PFA and request for his/her RSA Statement for the purpose of accessing the 25% of his/her RSA balance for payment of equity contribution.</li>
<li>In a joint application, each party shall apply to their respective PFA’s with copies of the verified property offer letter.</li>
<li>The PFA shall issue a duly endorsed RSA statement to the applicant, which the applicant shall forward to his/her Mortgage Lender.</li>
<li>The PFA shall update record on Applications for Equity Contribution for Residential Mortgage upon issuing the RSA Statement to RSA holder.</li>
<li>Upon receipt of the duly endorsed RSA statement, the Mortgage Lender shall verify if the 25% of the applicant’s RSA balance will be sufficient as equity contribution.</li>
<li>Where 25% of the RSA balance is sufficient as equity contribution, the Mortgage Lender shall issue a mortgage offer letter to the applicant.</li>
<li>Where 25% of the RSA balance(s) is not sufficient, the Mortgage Lender shall request for the payment of supplementary equity contribution from the applicant(s).</li>
<li>Upon confirmation of payment of supplementary equity contribution, the Mortgage Lender shall issue a mortgage offer to the applicant(s).</li>
<li>Within two working days of the issuance of the mortgage offer letter to the applicant(s), the Mortgage Lender shall forward a copy of the mortgage offer letter and the other documents</li>
<li>Evidence of payment of difference where 25% of RSA cannot cover the equity required</li>
<li>The applicant may after two working days of receiving his/her mortgage offer letter, approach his/her PFA to request for payment of his/her Equity Contribution for Residential Mortgage.</li>
<li>The applicant shall obtain and fill an Application Form, with indemnity to the PFA, for the payment of his/her Equity Contribution for Residential Mortgage.</li>
<li>In a joint application, each party shall apply to their respective PFA with a copy of the mortgage offer letter.</li>
<li>The PFA shall review the application form and the supporting documents received from the Mortgage Lender for completeness</li>
<li>Upon successful completion of the documentation review, the PFA shall update the applicant’s Mandate File within two working days.</li>
<li>If any exceptions or discrepancies are identified during the documentation review, the PFA shall communicate the exceptions to the Mortgage Lender within two working days of identifying such exceptions.</li>
<li>The PFA shall compute and validate that the requested amount is not more than 25% of his/her RSA Balance.</li>
<li>The PFA shall then process the application and forward same to the Commission within two working days of successful documentation review</li>
</ol>
        </div>
        `},
            {
                id: 66,
                question: 'Can the application be terminated, and equity contribution refunded? Yes, under there circumstances:',
                answer: `
<div class="answer-group">
<ol>
<li>In the event of foreclosure of the mortgage property.
<li>
In the event of death of any RSA holder in a joint application before the execution of the “Deed of Assignment”, the surviving partner shall have the following options:
<ol type="I">
<li>Proceed with the mortgage application until termination where cash flow is considered adequate</li>
<li>Terminate the application where cash flow is considered inadequate</li>
<li>Downscale the property to a smaller property that will accommodate the cash flow of the surviving partner. In this instance the applicant will start the application process afresh</li>
</ol>
</li>
<li>Where the RSA holder or the Mortgage Lender could not continue with the mortgage for any reason before the mortgage loan is approved and disbursed, the party that decides not to continue shall notify the PFA within one working day of arriving at such decisions.</li>
<li>If the property that has been presented becomes unavailable before the mortgage is approved and disbursed, the Mortgage Lender shall notify the applicant and the PFA within one working day of determining the unavailability of the property.</li>
<li>Where the RSA holder or the Mortgage Lender could not continue with the mortgage for any reason before the execution of the “Deed of Assignment”, the Mortgage Lender shall refund the equity contribution to the PFC within two working days after which such decision was made.</li>
</ol>
        </div>
        `},
        ]
    }
];